import {useContext, useRef, useState} from 'react'
import { GeometryContext } from '../store/store'
import {RigidBody} from '@react-three/rapier'
import { useFrame } from '@react-three/fiber'
import { Euler, Quaternion } from 'three'
import {useSelector} from 'react-redux'

const BlockSpinner = ({position = [0,0,0]}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)
    const obstacle = useRef()
    const [speed] = useState(()=> (Math.random() + 0.2) * (Math.random() < 0.5 ? -1 : 1) )

    useFrame((state, delta)=>{
        const time = state.clock.getElapsedTime()
        const rotation = new Quaternion()
        rotation.setFromEuler(new Euler(0,time * speed,0))
        obstacle.current.setNextKinematicRotation(rotation)
    })

    return (
        <group position={position}>
            <mesh 
                geometry={geometryCtx.boxGeometry} 
                material={geometryCtx.floor2Material} 
                scale={[4,0.2,4]}
                receiveShadow
                position={[0,-0.1,0]}
            />
            <RigidBody ref={obstacle} type='kinematicPosition' position={[0,0.2,0]} restitution={0.2} friction={0}>
                <mesh 
                    geometry={geometryCtx.boxGeometry} 
                    material={geometryCtx.obstacleMaterial} 
                    scale={[3.5,0.3,0.3]}
                    castShadow
                />
            </RigidBody>
        </group>
    )
}

export default BlockSpinner